import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { theme } from "./styles/theme";
import { AppBar } from "./components/layout/AppBar";
import { StackList } from "./components/stacks/StackList";
import { TrafficLightGrid } from "./components/visualizations/TrafficLightGrid";
import { Footer } from "./components/layout/Footer";
import { useAppStore } from "./store";

export default function App() {
  const { displayMode } = useAppStore();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          bgcolor: "background.default",
        }}
      >
        <AppBar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            overflow: "auto",
          }}
        >
          {displayMode === "stacks" ? <StackList /> : <TrafficLightGrid />}
        </Box>
        <Footer />
      </Box>
    </ThemeProvider>
  );
}
